import * as React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { get } from "../api";

async function get_order(order_id) {
  return await get(`/order/${order_id}`);
}
async function get_checkout(order_id) {
  return await get(`/order_information/checkout_price/${order_id}`);
}
function useOrder(order_id) {
  const orderQuery = useQuery({
    queryKey: ["order", order_id],
    queryFn: async () => await get_order(order_id),
  });
  const checkoutQuery = useQuery({
    queryKey: ["checkout", order_id],
    queryFn: async () => await get_checkout(order_id),
  });

  return {
    orderQuery,
    checkoutQuery,
    isSuccess:
      orderQuery.status === "success" && checkoutQuery.status === "success",
    order: orderQuery.data,
    checkout: checkoutQuery.data,
  };
}
export default useOrder;
